import { IMenuListStyle } from '../models/index.js';
export const menuListStyle: IMenuListStyle = {
	min: {
		width: '150px',
	},
	listStyle: {
		_value: 'none',
	},
	margin: {
		_value: '0',
	},
	padding: {
		_value: '4px 0',
	},
};
